<app-page [simpleTopBar]="true" [title]="title">
  <post-thread (postLoaded)="title = $event"></post-thread>
</app-page>
